import { useFormik } from 'formik';
import React, { useContext, useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  getProfilebyId,
  loginApi,
} from '../../apis/index.js';
import {
  WltSignInValidation,
} from '../../components/Validation/index.js';
import OneSignal from 'react-onesignal';
import { verifyToken } from '../../apis/index.js';
import { AppContext } from '../../appContext/index.js';
import MobileLoginView from '../../PageComponent/Account/MobileLoginView.js';
import DesktopLoginView from '../../PageComponent/Account/DesktopLoginView.js';


export default function GoogleSignIn({
  formGreetings,
  formSubGreetings,
  formType,
}) {
  const navigate = useNavigate();
  async function runOneSignal(id) {
    try {
      console.log(id)
      OneSignal.login(id)
      console.log('Login successful');
    } catch (error) {
      console.error('Error logging in:', error);
    }
  }
  const onVerifyToken = async (values) => {
    try {
      setLoader(true);
      const response = await verifyToken(values);
      if (response.status === 200) {
        localStorage.setItem('userId', response.data.userid);
        const res2 = await getProfilebyId(response.data.userid);
        if (res2.status === 200) {
          var hospitaldata = res2?.data?.Profile?.hospitalProfile;
          console.log(hospitaldata)
          if (hospitaldata) {
            if (!hospitaldata?.isApproved) {
              navigate('/Registration');
            } else {
              await runOneSignal(hospitaldata?._id)
              localStorage.setItem('token', response.data.token);
              navigate('/');
            }
          } else {
            navigate('/Registration');
          }
        }
      }
    } catch (error) {
      console.log(error)
      setLoader(false);
      toast.error(error?.response?.data?.message, { id: '001' });
    }
  };
  const responseMessage = (response) => {
    console.log(response)
    const values = { token: response.credential };
    onVerifyToken(values);
  };
  const errorMessage = (error) => {
    console.log(error);
  };

  const formik = useFormik({
    initialValues: { email: '', keepLoggedIn: false },
    validationSchema: WltSignInValidation,
    onSubmit: async (values) => {
      const { email } = values;
      try {
        setLoader(true);
        const res = await loginApi({ email });
        if (res.status === 200) {
          toast.success(res.data.message);
          navigate('/otp', {
            state: {
              email: formik.values.email,
              keepLoggedIn: formik.values.keepLoggedIn,
            },
          });
        }
      } catch (error) {
        setLoader(false);
        const message =
          error.response.data.message || error.response.statusText;
        toast.error(message, { id: 'error' });
      }
    },
  });
  const [loader, setLoader] = useState(false);

  return (
    <>
      {window?.innerWidth < 1024 ? (
        <MobileLoginView
          formGreetings={formGreetings}
          formSubGreetings={formSubGreetings}
          formType={formType}
          onVerifyToken={(val) => { onVerifyToken(val) }}
          runOneSignal={runOneSignal}
        />
      ) : (
        <DesktopLoginView
          formGreetings={formGreetings}
          formSubGreetings={formSubGreetings}
          responseMessage={responseMessage}
          errorMessage={errorMessage}
          runOneSignal={runOneSignal}
          formType={formType}
        />
      )}


    </>
  );
}

